import React from 'react';

/**
 * Compact label/value pair for use inside a 2-column grid:
 *   <dl className="grid grid-cols-2 gap-3">
 *     <DetailField label="Invoice" value="PFI000001" />
 *   </dl>
 */
const DetailField = ({ label, value, isDarkMode = false, className = '' }) => (
  <>
    <dt className={`text-xs font-medium uppercase tracking-wide ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} ${className}`}>
      {label}
    </dt>
    <dd className={`text-sm font-medium ${isDarkMode ? 'text-gray-100' : 'text-gray-900'}`}>
      {value === null || value === undefined || value === '' ? '-' : value}
    </dd>
  </>
);

export default DetailField;
